<template>
  <div class="email-preview bg-white">
    <div class="loader" v-if="previewLoading">
      <b-spinner label="Updating Preview..."></b-spinner>
    </div>

    <div v-html="previewHtml" class="preview-html"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'EmailPreview',

  computed: {
    ...mapState('emails', [
      'previewHtml'
    ]),

    ...mapGetters('emails', [
      'previewLoading'
    ])
  }
}
</script>

<style scoped>
  .email-preview {
    position: relative;
  }

  .loader {
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9998;
    align-items: center;
    justify-content: center;
    background: radial-gradient(#FFF, rgba(255, 255, 255, 0.5));
  }
</style>
